export function LeaderCrown() {
  return (
    <span
      role="img"
      aria-label="Party leader"
      title="Party leader"
      className="shrink-0 leading-none -translate-y-[2px]"
    >
      👑
    </span>
  );
}
